
    import { defineComponent } from 'vue'
    import XBreadcrumb from '../../components/Breadcrumb.vue';
    import housingTypeService from '@/apps/shared/services/getHouseType-service';
    import BuildingSurfaceService from '@/apps/shared/services/getBuildingSurfaceLimits-service';
    import localityService from '@/apps/shared/services/locality-service';

    export default defineComponent({
        components: {
            XBreadcrumb,
        },
        data() {
            return {
                isBack: false,
                breadcrumItems: [
                    { text: 'Inicio', path: '/hogar-premium' },
                    { text: 'Cotizá tu hogar', path: '/hogar-premium/cotizar' },
                ],
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                selectedLocality: null,
                cityId: null,
                zipCode: null,
                houseTypes: [{ id: "", text: "" }],
                articleCode: null,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                buildingSurfaceMin: null,
                buildingSurfaceMax: null,
                surfaceHouse: null,
                buildTypeCode: null,
                dataTwoTabJson: null,
                backExit: false,
            }
        },

        created() {
            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },

        methods: {
            siguiente() {

                var validSelectedArticleCode = this.articleCode != null;
                var validSelectedSurfaceHouse = this.surfaceHouse != null;
                var validSelectedLocality = this.selectedLocality != null;
                if (validSelectedArticleCode && validSelectedSurfaceHouse && validSelectedLocality && ((this.surfaceHouse >= this.buildingSurfaceMin) && (this.surfaceHouse <= this.buildingSurfaceMax))) {
                    window.globalThis.dataLayer.push({ 'product': 'hogarPremium', 'event': 'cotizador-hogar-premium-datos-vivienda' });
                    var dataTwoTab = {
                        articleCode: this.articleCode,
                        surfaceHouse: this.surfaceHouse,
                        selectedLocality: this.selectedLocality,
                        buildTypeCode: this.buildTypeCode,
                        buildingSurfaceMin: this.buildingSurfaceMin,
                        buildingSurfaceMax: this.buildingSurfaceMax
                    }
                    sessionStorage.removeItem("TabTwoData");
                    sessionStorage.setItem("TabTwoData", JSON.stringify(dataTwoTab));

                    if (this.backExit) {
                        sessionStorage.setItem("ExitOrContinueModal", "false");
                    }
                    else {
                        sessionStorage.setItem("ExitOrContinueModal", "true")

                    }
                    sessionStorage.setItem("FromPassTabTwo", "true");

                    this.$router.push({
                        name: 'tabThreeFamilyCombinedPremium',
                    })

                    NF.UI.Page.unblock();
                }
                //else {
                //    NF.Notification.show({
                //        type: NF.Notification.Type.ERROR,
                //        title: 'Error',
                //        content: 'Se produjo un error',
                //        position: NF.Notification.Positions.TOP_RIGHT,
                //        clickClose: true,
                //        autoHideDelay: 10000,
                //    });

                //    NF.UI.Page.unblock();
                //}
            },

            getHousingType() {
                housingTypeService.getHousingTypes().then((response) => {
                    if (response.length != 0) {
                        this.houseTypes = response.map(element =>
                            ({ ...element, id: element["article"], text: element["description"] }))
                    }
                });
            },

            getBuildingSurfaceLimits() {
                BuildingSurfaceService.getBuildingSurfaceLimits().then(buildingSurface => {
                    this.buildingSurfaceMin = buildingSurface["minLimit"];
                    this.buildingSurfaceMax = buildingSurface["maxLimit"];

                    NF.Validation.Field.addField('#formTabTwo', 'surfaceHouse', {
                        validators: {
                            between: {
                                min: this.buildingSurfaceMin,
                                max: this.buildingSurfaceMax
                            },
                        },
                    })
                });
            },

            isNumberKey(event) {
                var charCode = event.which ? event.which : event.keyCode;
                if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                    event.preventDefault();
                }
            },

            volver() {
                sessionStorage.setItem("ExitOrContinueModal", "false");
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'tabOneFamilyCombinedPremium',
                })
            },
        },

        watch: {
            selectedLocality(newVal) {
                if (this.selectedLocality != null) {
                    this.localityIsSelected = true;
                    this.cityId = newVal.id;
                    this.zipCode = newVal.zipCode;
                }
            },
        },

        mounted() {
            NF.UI.Page.block();
            this.getHousingType();
            this.getBuildingSurfaceLimits();
            sessionStorage.setItem("ExitOrContinueModal", "true");
            var validBack = sessionStorage.getItem("pressBack");
            if (validBack) {
                sessionStorage.removeItem("pressBack");
                this.backExit = true;
            }
            else {
                this.isBack = false;
                this.backExit = false;
            }
            var dataTwoTab = sessionStorage.getItem("TabTwoData");
            if (dataTwoTab != null) {
                new Promise<any>(async (resolve) => {
                    await BuildingSurfaceService.getBuildingSurfaceLimits().then(async buildingSurface => {
                        this.buildingSurfaceMin = buildingSurface["minLimit"];
                        this.buildingSurfaceMax = buildingSurface["maxLimit"];
                        this.dataTwoTabJson = JSON.parse(dataTwoTab!);
                        this.articleCode = this.dataTwoTabJson.articleCode;
                        this.surfaceHouse = this.dataTwoTabJson.surfaceHouse;
                        this.selectedLocality = this.dataTwoTabJson.selectedLocality
                    })
                })
                NF.UI.Page.unblock();
            }
            else {
                NF.UI.Page.unblock();
            }
        }

    })
